import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, } from "react"
import {Modal, Row, Col, Radio, Input, message } from "antd"
import { orderReview } from "@/service/ordersService"


 export default  (props) => {
    const { t } = useTranslation();
    const { visible, setVisible, onSuccess, orderId } = props //拍单信息
    const [ passed,setPassd] = useState(true)
    const [ str, setStr] = useState("")
    const [confirmLoading, setConfirmLoading]= useState(false)
    useEffect(() => {

    }, [visible])
    //机构列表
    useEffect(() => {
       console.log(orderId)
    }, [])


    const onOk = () => {
        if (passed || (!passed && str)) {
            setConfirmLoading(true)
            orderReview({
                orderId: orderId,
                passed: passed,
                rejectInfo: passed ? "" : str,
            }).then((res) => {
                onSuccess && onSuccess()
                message.success(t(`ordersManage.ordersManage.reviewModal.审核成功`))
                setVisible(false)
            }).finally(() => {
                setConfirmLoading(false)
            })
        } else {
            message.warning(t(`ordersManage.ordersManage.reviewModal.请输入工单驳回的原因`))
        }
       
    }

    return (
        <Modal forceRender visible={visible} title= {t(`ordersManage.ordersManage.reviewModal.订单审核`)} centered={true} onOk={() => onOk()} onCancel={() => setVisible(false)} width={400} confirmLoading={confirmLoading}>
            <Row style={{ marginBottom: "10px" }}>
                                <Col span="6"> {t(`ordersManage.ordersManage.reviewModal.审核状态`)}</Col>
                                <Col span="16">
                                    <Radio.Group
                                        onChange={(e) => {
                                            setPassd(e.target.value)
                                        }}
                                        value={passed}
                                    >
                                        <Radio value={true}>{t(`ordersManage.ordersManage.reviewModal.通过`)}</Radio>
                                        <Radio value={false}>{t(`ordersManage.ordersManage.reviewModal.驳回`)}</Radio>
                                    </Radio.Group>
                                </Col>
                            </Row>

                            {!passed && (
                                <Row>
                                    <Col span="6">{t(`ordersManage.ordersManage.reviewModal.驳回原因`)}</Col>
                                    <Col span="16">
                                        <Input
                                            placeholder={t(`ordersManage.ordersManage.reviewModal.请输入工单驳回的原因`)}
                                            onChange={(e) => {
                                                setStr(e.target.value) 
                                            }}
                                        />
                                    </Col>
                                </Row>
                            )}
        </Modal>
    )
}

